import type { ButtonGroupOption } from '/react4xp/components/react-hook-form/ButtonGroup';
import type { Phrases } from '../Phrases.d';


import React, { useEffect, useRef } from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { Legend } from '../../../../components/Element';
import { Fieldset } from '/react4xp/components/react-hook-form/Fieldset';
import { CapsulePowderColorButtonGroup } from './CapsulePowderColorButtonGroup';
import { CapsulePowderColorOtherTextField } from './CapsulePowderColorOtherTextField';
import {
	type SubstanceForm,
	COMMON_FIELD_NAME,
	SUBSTANCE_FORM,
} from '../constants';


const CAPSULE_POWDER_COLOR_LEGEND_ID = 'capsulePowderColorLegend';


export const CapsulePowderColorFieldset = ({
	capsulePowderColorOptions,
	phrases,
}: {
	capsulePowderColorOptions: ButtonGroupOption[];
	phrases: Phrases;
}): React.JSX.Element => {
	const legend = phrases['notificationForm.common.capsulePowderColorField.label'];
	const {
		control,
		setScrollRef,
	} =	useFormContext();

	const scrollRef = useRef();
	const substanceForm: SubstanceForm = useWatch({ control, name: COMMON_FIELD_NAME.SUBSTANCE_FORM}) as SubstanceForm;
	const isCapsule = substanceForm === SUBSTANCE_FORM.CAPSULE;

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({ field: COMMON_FIELD_NAME.CAPSULE_POWDER_COLOR_OTHER, el: scrollRef.current });
		}
	}, [scrollRef.current]);

	return (
		<Fieldset
			borderless
			className={isCapsule ? undefined : 'hidden'}
			elementRef={scrollRef}
			legend={isCapsule ? legend : undefined}
			legendClassName='font-normal text-lg'
			legendId={CAPSULE_POWDER_COLOR_LEGEND_ID}
			name={COMMON_FIELD_NAME.CAPSULE_POWDER_COLOR}
		>
			<CapsulePowderColorButtonGroup
				aria-labelledby={CAPSULE_POWDER_COLOR_LEGEND_ID}
				capsulePowderColorOptions={capsulePowderColorOptions}
				phrases={phrases}
			/>
			<CapsulePowderColorOtherTextField
				phrases={phrases}
			/>
		</Fieldset>
	);
};
